import IconBox from '../../components/common/icon-box'
import MainNav from '../../components/homepage/main-nav'
import Layout from '../../components/layout/layout'
import InfoMessage from '../../components/common/info-message'
import { useTranslation } from '../../useTranslation'
import Button from '../../components/common/button'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

const NewsletterError = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    return (
        <Layout>
            <MainNav />
            <div className="mx-auto my-16 w-3/6 max-tablet:w-2/3">
                <IconBox icon="address-card">
                    <div className="py-10 px-2">
                        <InfoMessage type="error" label={t('footer.newsletter.newsletterError')} icon="xmark" dataCy="newsletter-error-message" />
                        <div className="flex justify-center mt-7 gap-3">
                            <Button type={'squareYellow'} icon="chevron-left" text={t('back')} onClick={() => navigate(-1)} dataCy="newsletter-error-back" />
                            <Link to="/">
                                <Button text={t('backToRingo')} type="squareBlue" dataCy="newsletter-error-back-home" />
                            </Link>
                        </div>
                    </div>
                </IconBox>
            </div>
        </Layout>
    )
}

export default NewsletterError
